export default __webpack_public_path__ + "static/media/toShow-2-min.44f33132.jpg";